import styled from 'styled-components';
import { Box, Typography } from '@mui/material';

export const ModalWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgb(255, 255, 255);
  border-radius: 8px;
  outline: none;
  width: 90vw;
  min-height: 80vh;
  max-width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;

  @media (min-width: 600px) {
    width: 80vw;
    min-height: 80vh;
  }

  @media (min-width: 960px) {
    width: 70vw;
  }
`;

export const ModalHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitleContainer = styled.div`
  flex: 1;
`;

export const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const ModalDescription = styled.p`
  font-size: 0.875rem;
  color: #64748b;
  margin: 4px 0 0 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #64748b;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f1f5f9;
    color: #1e293b;
  }
`;

export const ModalContent = styled.div`
  padding: 24px;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;

  @media (max-width: 600px) {
    padding: 12px 16px;
  }
`;

export const TabsContainer = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #e2e8f0;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #293778;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #1e2654;
  }
`;

export const TabsList = styled.div`
  display: inline-flex;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 16px;
`;

export const TabButton = styled.button<{ active: boolean }>`
  padding: 8px 16px;
  background: none;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${(props) => (props.active ? '#293778' : '#64748b')};
  cursor: pointer;
  border-bottom: 2px solid
    ${(props) => (props.active ? '#293778' : 'transparent')};
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  gap: 8px;

  &:hover {
    color: ${(props) => (props.active ? '#293778' : '#1e293b')};
  }
`;

export const TabIndicator = styled(Box)`
  width: 12px;
  height: 12px;
  border-radius: 1px;
  flex-shrink: 0;
`;

export const SectionHeading = styled.div`
  font-size: 1.125rem;
  font-weight: 500;
  color: #1e293b;
  margin: 0;
`;

export const ContentHeader = styled.div``;

export const NoRisksContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 16px;
  width: 100%;
`;

export const NoRisksText = styled(Typography)`
  margin-top: 8px;
  color: #64748b;
  font-size: 1rem;
`;
